module.exports = __webpack_public_path__ + "img/Login_logo.2058d6f0.png";